// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__30jOw","form":"styles_form__2JIcI"};